import { render, staticRenderFns } from "./IGDclinic.vue?vue&type=template&id=cc651438&scoped=true"
import script from "./IGDclinic.vue?vue&type=script&lang=js"
export * from "./IGDclinic.vue?vue&type=script&lang=js"
import style0 from "./IGDclinic.vue?vue&type=style&index=0&id=cc651438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc651438",
  null
  
)

export default component.exports